export default ($) => {
  let loadMore = $('.js-loadMore');
  let loadMoreSearch = $('.js-loadMoreSearch');

  if (!loadMore.length && !loadMoreSearch.length) return;

  const { ajaxurl, current_page, found_posts, max_page, posts_per_page } = wp_params;

  if (parseInt(found_posts) <= parseInt(posts_per_page)) {
    loadMore.closest('div').remove();
    loadMoreSearch.closest('div').remove();
    return;
  }

  let isSearch = loadMore.data('search') || false;
  let searchQuery = loadMore.data('searchquery') || '';
  let action = isSearch ? 'load_more_search_posts' : 'load_more_posts';

  let postType  = loadMore.data('type');
  let container = $(loadMore.data('container'));
  let term      = loadMore.data('term');
  let termId    = loadMore.data('termid');
  let template  = loadMore.data('template');
  let page = current_page;

  loadMore.on('click', function (e) {
    e.preventDefault();

    if (page >= max_page) return;

    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: action,
        page: parseInt(page) + 1,
        post_type: postType,
        term: term,
        termId: parseInt(termId),
        viewTemplate: template,
        search: isSearch,
        s: searchQuery
      },
      beforeSend: function () {
        loadMore.html('<span>Loading...</span>');
      },
      success: function (response) {
        if (response) {
          if (response?.data?.html) {
            container.append(response.data.html);

            page++;
            wp_params.current_page = page;

            if (page >= max_page) {
              loadMore.closest('div').remove();
            } else {
              loadMore.html('<span>Load More</span>');
            }
          } else {
            loadMore.closest('div').remove();
          }
        } else {
          loadMore.closest('div').remove();
        }
      },
      error: function () {
        loadMore.html('<span>Error. Please try later.</span>');
      }
    });
  });

  loadMoreSearch.click(function () {
    var btn = $(this);
    var page = parseInt(btn.data("page"));
    var query = btn.data("query");
    let container = $(btn.data('container'));

    $.ajax({
      type: "POST",
      url: ajaxurl,
      data: {
        action: "load_more_search_posts",
        paged: page,
        s: query,
      },
      beforeSend: function () {
        btn.html('<span>Loading...</span>');
      },
      success: function (response) {
        if ($.trim(response) !== "") {
          container.append(response);
          btn.data("page", page + 1);
          btn.attr("data-page", page + 1);
          btn.html("<span>Load More</span>");
        } else {
          btn.remove();
        }
      },
      error: function () {
        loadMore.html('<span>Error. Please try later.</span>');
      }
    });
  });
}